import styled from "styled-components";

import { layout } from "/styles";

export const ButtonVerticalContainer = styled.div(
  layout.flexVertical,
  layout.spacedChildrenVertical(),
  layout.paddingVertical("expanded"),
);
